import React from 'react'

import {
  scenarioDateComparator,
  scenarioDateFilterParams
} from 'components/AgGridCustomFilters/helpers'
import { commonColumnProps } from 'pages/Scenario/utils/table'

import { Loading } from '@ublique/components/Loading'
import CustomDateComponent from 'components/AgGridCustomFilters/CustomDateComponent'

import DateColumnFramework from '../components/DateColumnFramework'
import TitleColumnFramework from '../components/TitleColumnFramework'
import StatusColumnFramework from '../components/StatusColumnFramework'
import SummaryColumnFramework from '../components/SummaryColumnFramework'
import TranslateColumnFramework from '../components/TranslateColumnFramework'
import CrontabColumnFramework from '../components/CrontabColumnFramework'
import MailToColumnFramework from '../components/MailToColumnFramework'
import { DATE_FORMAT } from '../constants'
import cronstrue from 'cronstrue/i18n'

export const getScenarioColumns = (t) => [
  {
    ...commonColumnProps,
    headerName: t('Table.RULE'),
    field: 'query',
    colId: 'query',
    minWidth: 180,
    wrapText: true,
    tooltipShowDelay: 0,
    tooltipValueGetter: (params) => params.value
  },
  {
    ...commonColumnProps,
    headerName: t('Table.USERNAME'),
    field: 'username',
    colId: 'username',
    minWidth: 130
  },

  {
    ...commonColumnProps,
    headerName: t('Table.CREATION_DATE_TIME'),
    headerTooltip: t('Table.CREATION_DATE_TIME'),
    field: 'creationDateTime',
    colId: 'creationDateTime',
    minWidth: 200,
    filter: 'agDateColumnFilter',
    cellRenderer: 'dateRenderer',
    comparator: scenarioDateComparator(DATE_FORMAT),
    filterParams: scenarioDateFilterParams(DATE_FORMAT),
    cellRendererParams: {
      showTime: true
    }
  },
  {
    ...commonColumnProps,
    headerName: t('Table.LAST_TRIGGER'),
    headerTooltip: t('Table.LAST_TRIGGER'),
    field: 'lastTrigger',
    colId: 'lastTrigger',
    minWidth: 190,
    filter: 'agDateColumnFilter',
    cellRenderer: 'dateRenderer',
    comparator: scenarioDateComparator(DATE_FORMAT),
    filterParams: scenarioDateFilterParams(DATE_FORMAT),
    cellRendererParams: {
      showTime: true
    }
  },
  {
    ...commonColumnProps,
    headerName: t('Table.NEXT_TRIGGER'),
    headerTooltip: t('Table.NEXT_TRIGGER'),
    field: 'nextTrigger',
    colId: 'nextTrigger',
    minWidth: 180,
    filter: 'agDateColumnFilter',
    cellRenderer: 'dateRenderer',
    comparator: scenarioDateComparator(DATE_FORMAT),
    filterParams: scenarioDateFilterParams(DATE_FORMAT),
    cellRendererParams: {
      showTime: true
    }
  },
  {
    ...commonColumnProps,
    headerName: t('Table.CRON_START'),
    headerTooltip: t('Table.CRON_START'),
    field: 'cronStart',
    colId: 'cronStart',
    minWidth: 190,
    filter: 'agDateColumnFilter',
    cellRenderer: 'dateRenderer',
    comparator: scenarioDateComparator(DATE_FORMAT),
    filterParams: scenarioDateFilterParams(DATE_FORMAT),
    cellRendererParams: {
      showTime: true
    }
  },
  {
    ...commonColumnProps,
    headerName: t('Table.CRON_END'),
    headerTooltip: t('Table.CRON_END'),
    field: 'cronEnd',
    colId: 'cronEnd',
    minWidth: 180,
    filter: 'agDateColumnFilter',
    cellRenderer: 'dateRenderer',
    comparator: scenarioDateComparator(DATE_FORMAT),
    filterParams: scenarioDateFilterParams(DATE_FORMAT),
    cellRendererParams: {
      showTime: true
    }
  },
  {
    ...commonColumnProps,
    headerName: t('Table.MAIL_TO'),
    field: 'mails',
    colId: 'mails',
    tooltipField: 'mails',
    minWidth: 180,
    cellRenderer: 'mailToRenderer',
    floatingFilter: false
  }
]

export const getStandardColumnDefs = (t) => [
  {
    ...commonColumnProps,
    headerName: t('Table.SCENARIO_PURGER_NAME'),
    field: 'scenarioPurgeName',
    colId: 'scenarioPurgeName',
    minWidth: 300,
    pinned: 'left',
    tooltipField: 'scenarioPurgeName',
    cellRenderer: 'nameRenderer',
    checkboxSelection: true,
    headerCheckboxSelection: true,
    headerCheckboxSelectionFilteredOnly: true,
    lockVisible: true
  },
  {
    ...commonColumnProps,
    headerName: t('Table.ENABLED'),
    field: 'enabled',
    colId: 'enabled',
    pinned: 'right',
    minWidth: 180,
    cellRenderer: 'statusRenderer',
    floatingFilter: false,
    lockVisible: true
  },
  {
    suppressMovable: true,
    headerName: t('Table.CRON_EXP'),
    field: 'cronExp',
    colId: 'cronExp',
    pinned: 'right',
    minWidth: 200,
    floatingFilter: false,
    lockVisible: true,
    cellRenderer: 'crontabRenderer',
    tooltipValueGetter: ({ value }) => {
      const lang = localStorage.getItem('i18n-lang')
      const locale = lang ? lang.split('-')[0] : 'en'
      return value ? cronstrue?.toString(value, { locale }) : ''
    }
  }
]

export const columnFrameworks = {
  // Custom loading
  customLoadingOverlay: () => <Loading />,

  // Custom columns
  dateRenderer: DateColumnFramework,
  nameRenderer: TitleColumnFramework,
  statusRenderer: StatusColumnFramework,
  summaryRenderer: SummaryColumnFramework,
  translateRenderer: TranslateColumnFramework,
  crontabRenderer: CrontabColumnFramework,
  mailToRenderer: MailToColumnFramework,

  // Date custom
  agDateInput: CustomDateComponent
}
